import script from "./FamilyNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyNumber.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyNumber.vue?vue&type=style&index=0&id=21427040&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21427040"]])

export default __exports__